module.exports = __webpack_public_path__ + "media/sessions/conference@2x-fead437e.png";